import { Text, Link, useIsDesignLanguage, DesignLanguage } from '@afterpaytouch/core'
import React, { FunctionComponent } from 'react'

import { useCheckoutSizes } from '../../utils/responsive'
import { useTranslation } from 'next-i18next'

import styles from './style.module.css'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { useMobileLogin } from '../../state'
import { useRouter } from 'next/router'
import { Route } from '../../config/router'

interface LoginHelpLinkProps {
  pageName: string
}

export const LoginHelpLink: FunctionComponent<LoginHelpLinkProps> = ({ pageName }) => {
  const { t } = useTranslation()
  const { pathname } = useRouter()
  const { textSize } = useCheckoutSizes()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const { isMobileLogin } = useMobileLogin()

  const handleOnClick = (): void => {
    logEvent(`Pressed ${pageName} Need Help`)
  }

  return (
    <>
      {isMobileLogin && (
        <div className={styles.helpLinkWrapper}>
          <Link target='_blank' kind='Underline' href={t('login:helpArticleUrl')} onClick={handleOnClick}>
            <Text size={textSize} bold color={isArcadeDesignLanguage ? 'Inverse Dark' : undefined}>
              {t(pathname === Route.ENTER_PASSWORD ? 'password:needHelpLink' : 'login:helpArticleLinkText')}
            </Text>
          </Link>
        </div>
      )}
    </>
  )
}
